export function parseEmail(email) {
  return email.toLowerCase().replace(/[^a-z0-9.!#$%&'*+/=?^_`{|}~\-@]+/g, '');
}

export function isValidEmail(email) {
  if (!email || email.length < 2 || email.length > 100)
    return false;
  return /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*$/.test(email);
}
